application.async = new Async();
function Async()
{

	var self = this;

	self.awake = function()
	{
		// Async Web Font loader
		/*WebFont.load({
			google: {
				families: ['Source Sans Pro:300,400,600,700']
			}
		});*/
				
	};

	/*
	self.ready = function()
	{
		
	};

	self.loaded = function()
	{
		
	};

	self.resize = function( e )
	{
		debug.log( e.message );
	};
	*/

	ApplicationObject.call( this );
}
Async.prototype = Object.create( ApplicationObject.prototype );